import type { ProductionOrderSheet, SaveProductionOrderSheetInput } from '@repo/api-contracts';
import { useInvalidateOrders } from '@/entities/order';
import { trpc } from '@/shared/api';

/**
 * 발주서 저장(orderManagement.saveProductionOrderSheet). 저장 뒤 발주서 조회를 다시 불러온 다음 저장된 발주서를 돌려준다.
 * 실패는 서버 오류를 그대로 던진다 — 문구는 호출한 폼이 정한다.
 */
export const useSaveProductionOrderSheet = (): ((
  input: SaveProductionOrderSheetInput,
) => Promise<ProductionOrderSheet>) => {
  const orders = useInvalidateOrders();
  const mutation = trpc.orderManagement.saveProductionOrderSheet.useMutation();

  return async (input) => {
    const sheet = await mutation.mutateAsync(input);
    await orders.productionSheet(input.orderId);
    return sheet;
  };
};
